module.exports = __webpack_public_path__ + "img/boy-thinking.f5f75236.gif";